import React from 'react';
import Header from './components/Header';
import './styles/style.css';

//export
const App = () => {
	return (
		<div>
			<Header />
		</div>
	);
}

export default App;
